import { currentOrigin } from 'src/app-config';
import { FC, useEffect, useRef, useState } from 'react';
import { houseToHouseServices, hthHelper } from 'src/services';
import { setAlertResponse } from 'src/store';
import { typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig } from 'src/custom-hooks';
import { WhatsAppIcon1 } from 'src/components/_commons';
import { WhatsappShareButton } from 'react-share';

type propsType = {
    currentFace: typeHTHFace;
    territoryNumber: typeTerritoryNumber;
};

export const HTHFaceBuildingsShareButton: FC<propsType> = ({ currentFace, territoryNumber }) => {
    const [isShareButtonDisabled, setIsShareButtonDisabled] = useState(true);
    const [url, setUrl] = useState('');
    const config = useGetConfig();
    const dispatch = useDispatch();
    const shareButton = useRef<any>(null);

    const shareBuildingHandler = async () => {
        const checkboxes = Array.from(document.getElementsByClassName('share-building')) as Array<HTMLInputElement>;
        if (!checkboxes) {
            return;
        }
        const buildings: number[] = [];
        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                const streetNumber = parseInt(checkbox.value.includes('/') ? checkbox.value.split('/')[0] : checkbox.value);
                if (streetNumber && !isNaN(streetNumber)) {
                    buildings.push(streetNumber);
                }
                checkbox.checked = false;
            }
        });
        if (!buildings.length) {
            return;
        }
        const response = await houseToHouseServices.SetIsSharedBuildings(territoryNumber, currentFace.block, currentFace.face, buildings);
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        const text = hthHelper.GetLinkTextForShareFaceBuildings(currentOrigin, config.congregation, territoryNumber, currentFace.block, currentFace.face, currentFace.street, buildings);
        setUrl(text);
    }

    useEffect(() => {
        setInterval(() => {
            const someChecked = (Array.from(document.getElementsByClassName('share-building')) as Array<HTMLInputElement>)?.some(x => x.checked);
            setIsShareButtonDisabled(!someChecked);
        }, 300);
    }, []);

    useEffect(() => {
        if (!shareButton.current || !url) {
            return;
        }
        try {
            shareButton.current.click();
        } catch (error) {
            console.log(error);
        }
        (Array.from(document.getElementsByClassName('share-building')) as Array<HTMLInputElement>)?.forEach(checkbox => {
            if (checkbox.checked) {
                checkbox.checked = false;
            }
        });
    }, [url]);

    return (
        <>
        <button className={'btn btn-general-blue d-block mx-auto mt-4'} style={{ width: '300px' }}
            onClick={shareBuildingHandler}
            disabled={isShareButtonDisabled}
        >
            &nbsp; Compartir por WhatsApp &nbsp; <WhatsAppIcon1 styles={{ width: '40px' }} />
        </button>
        <WhatsappShareButton
            className={'d-none'}
            ref={shareButton}
            style={{ marginTop: '7px' }}
            title={"EDIFICIOS - CASA EN CASA"}
            url={url}
            windowHeight={460}
            windowWidth={660}
        >
            <></>
        </WhatsappShareButton>
        </>
    );
}
